<template lang="pug">
  div
    v-navigation-drawer(
      v-if="showSidebar"
      v-model="drawer"
      :color="this.$vuetify.theme.currentTheme.drawer"
      :dark="true"
      :back-text="$t('Main menu')"
      :mini-variant="mini"
      :class="{'sidebar': true, 'mobile-active': sidebar }"
      :app="!(mdDevice && !mini)"
      id="app-sidebar"
      permanent
      clipped
      fixed
    )
      template(v-slot:prepend)
        v-list(class="py-0")
          v-list-item(dense one-line :class="mini ? 'px-3' : ''")
            v-list-item-content
              v-row(align="center" justify="center" style="margin-top:3px; width:100%")
                v-col(cols="12" class="sidebar__header justify-center")
                  div(class="d-flex align-center justify-center")
                    v-toolbar-title(
                      class="dashboard__title pb-0"
                      :title="$nuxt.$options.head.title"
                      @click="onMenuItemClick('/dashboard')"
                      style="margin-top: -4px"
                    )
                      v-img(
                        :src="mini ? require('~/assets/images/logo/Navkolo-logo-vector-white-mini.svg') : require('~/assets/images/logo/Navkolo-logo-vector-mono.svg')"
                        :contain="!mini"
                        :height="mini ? '27px': '56px'"
                        :width="mini ? '30px': '212px'"
                        :position="!mini ? 'left center': '0'"
                        aspect-ratio="1.7"
                      )

      v-list(:class="['pt-0']")
        v-list-item-group
          v-window(v-model="step")
            v-window-item(:value="1")
              div(style="flex-grow: 1;")
                template(v-for="(item, i) in items")
                  template(v-if="!item.children")
                    v-list-item(
                      v-if="getParam(item.visible, $User, true) && (('model' in item) ? $ability.can(ormActions.read, item.model) : true)"
                      active-class="active"
                      :key="i"
                      class="mt-2 sidebar__menu-item"
                      :to="item.href"
                    )
                      v-list-item-icon(v-if="item.icon" class="d-flex align-center justify-center")
                        component(:is="item.icon.type" v-bind="item.icon.options ? item.icon.options : {}") {{ item.icon.text }}

                      v-list-item-content
                        v-list-item-title(:role="item.href ? 'button' : null") {{ _.upperFirst($t(item.text)) }}
                          v-icon(v-if="item.children && item.children.length" right class="icon-right") mdi-chevron-right
                  template(v-if="item.children && item.children.length")
                    v-list-group(
                      :value="true"
                      disabled
                      append-icon=""
                      v-if="getParam(item.visible, $User, true) && (('model' in item) ? $ability.can(ormActions.read, item.model) : true)"
                      :class="[mini && 'sidebar__list-group--mini', i === 0 && 'no-links-hover']"
                    )
                      template(#activator)
                        v-list-item-content(class="py-0" v-if="!mini")
                          v-list-item-title(:role="item.href ? 'button' : null") {{ _.upperFirst($t(item.text)) }}
                      v-list-item(
                        v-for="(item, i) in item.children"
                        v-if="getParam(item.visible, $User, true) && (('model' in item) ? $ability.can(ormActions.read, item.model) : true) && showOnMobile(item)"
                        :key="i"
                        class="sidebar__menu-item"
                        :to="item.href ? item.href : null"
                        :href="item.link ? item.link : null"
                        :target="item.link ? '_blank' : null"
                        @click="onMenuItemClick()"
                        active-class="active"
                        dense
                      )
                        v-list-item-icon(v-if="item.icon" class="d-flex align-center justify-center")
                          component(:is="item.icon.type" v-bind="item.icon.options ? item.icon.options : {}") {{ item.icon.text }}

                        v-list-item-content
                          v-list-item-title(:role="item.href ? 'button' : null" :style="item.color ? {color: item.color} : {}") {{ _.upperFirst($t(item.text))}}
                            v-icon(v-if="item.children && item.children.length" right class="icon-right") mdi-chevron-right
                            span(v-if="item.beta && item.beta($Organization)" class="sidebar__note") {{ $t('Beta')}}
                  div(
                    v-if="getParam(item.visible, $User, true) && (('model' in item) ? $ability.can(ormActions.read, item.model) : true) && i !== items.length - 1"
                    class="px-3 mt-2 mb-2 sidebar__separator"
                  )
                    hr(size="1px" color="#32363f" class="sidebar__separator-line")

              div(v-if="xsDevice" class="px-4 pt-2")
                v-list-item-title(role="button" class="mb-3") {{ $t('Contacts') }}
                m-support-buttons(mobile)

              div
                v-list-item(
                  class="sidebar__menu-item mt-1"
                  @click="logout"
                )
                  v-list-item-icon(
                    class="d-flex justify-center align-center"
                    style="margin-top: 9px"
                  )
                    e-svg-icon(size="xmd") logout
                  v-list-item-content
                    v-list-item-title {{ $t('Logout') }}

                div(
                  v-if="superAdminToken"
                  class="sidebar__menu-item--bottom"
                  @click="backToAdmin"
                )
                  v-list-item-icon
                    v-icon mdi-chevron-left
                  span(v-if="!mini") {{ $t('Return to admin') }}

                div(
                  v-if="!xsDevice"
                  class="sidebar__menu-item--bottom mt-3"
                  @click="toggleMini"
                )
                  v-list-item-icon
                    v-icon(v-if="mini") mdi-chevron-right
                    v-icon(v-else class="mr-1") mdi-chevron-left
                  span(v-if="!mini") {{ $t('Collapse menu') }}

    div(class="mobile-menu" v-if="xsDevice")
      div(
        v-for="(item, index) in mobileMenuItems"
        :key="index"
        @click="item.call"
        :class="{'mobile-menu__item': true, 'active': item.active }"
      )
        e-svg-icon {{ item.icon }}
        div {{ $t(item.text) }}
</template>

<script>
import { VIcon } from 'vuetify/lib'
import { actions } from '~/const/global'
import { menuItems } from '~/const/menuItems'
import EFlatIcon from '~/components/elements/icons/e-flat-icon'
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import EProgressCircular from '~/components/elements/progress/e-progress-circular'
import auth from '~/modules/auth/auth'
import responsive from '~/mixins/pages/responsive'
import MSupportButtons from '~/components/modules/m-support-buttons'
import signPluginForOrganization from '~/mixins/dialogs/signPluginForOrganizationDialog'
import BlockNotificationsButton from '~/modules/notifications/views/components/block-notifications-button'
import taxAuth from '~/mixins/pages/tax-auth'

export default {
  components: {
    MSupportButtons,
    EProgressCircular,
    EFlatIcon,
    ESvgIcon,
    VIcon,
    BlockNotificationsButton
  },
  mixins: [responsive, signPluginForOrganization, taxAuth],
  data: () => ({
    step: 1,
    backText: null,
    drawer: true,
    mini: false,
    sidebar: false,
    showFriendBonus: true
  }),
  computed: {
    superAdminToken () {
      return auth.getSuperAdminAuthToken()
    },
    ormActions () {
      return actions
    },
    items () {
      return menuItems
    },
    notMobileDevice () {
      return this.mdDevice && !this.xsDevice
    },
    showSidebar () {
      return !this.xsDevice || this.sidebar
    },
    mobileMenuItems () {
      // const sellPath = '/dashboard/createreceipts'
      // const returnPath = '/dashboard/refundreceipt'
      return [
        // {
        //   text: 'Selling',
        //   icon: 'sell-3',
        //   active: this.$route.path === sellPath && !this.sidebar,
        //   call: () => this.mobileMenuItemClick(sellPath)
        // },
        // {
        //   text: 'Return',
        //   icon: 'selling-3',
        //   active: this.$route.path === returnPath && !this.sidebar,
        //   call: () => this.mobileMenuItemClick(returnPath)
        // },
        {
          text: 'Other',
          icon: 'menu',
          active: this.sidebar,
          call: () => {
            this.sidebar = !this.sidebar
          }
        }
      ]
    }
  },
  watch: {
    drawer (val) {
      this.$emit('input', val)
    }
  },
  created () {
    if (this.notMobileDevice) {
      this.mini = true
    }

    const storageClientData = localStorage.getItem('clientData') && JSON.parse(localStorage.getItem('clientData'))
    this.showFriendBonus = this._.get(storageClientData, 'showFriendBonus', true)
  },
  mounted () {
    const content = document.querySelector('.v-content')
    content.addEventListener('click', () => {
      if (this.notMobileDevice) {
        this.mini = true
      }
    })
  },
  methods: {
    showOnMobile (item) {
      return !(this.xsDevice && (item.href && (item.href.includes('createreceipts') || item.href.includes('refundreceipt'))))
    },
    mobileMenuItemClick (path) {
      this.sidebar = false
      this.$router.push(path)
    },
    onMenuItemClick (route) {
      if (route) {
        this.$router.push(route)
      }
      if (this.notMobileDevice) {
        this.mini = true
      } else {
        this.sidebar = false
      }
    },
    organizationChange () {
      this.signPluginForOrganization.close()
      this.$emit('rerenderContent')
    },
    toggleMini () {
      this.mini = !this.mini
    },
    getParam (param, item, def) {
      if (param === undefined) {
        return def
      }
      if (typeof param === 'function') {
        return param(item, this.$Organization)
      }
      return param
    },
    async backToAdmin () {
      await auth.applyAdminToken()
      this.$router.push('/dashboard/organizations')
    },
    async logout () {
      await auth.logout()
      this.destroyIitGlobalDialog()
      await this.$router.push({ name: 'auth-login' })
    }
  }
}
</script>

<style lang="scss">
.dashboard {
  &__title {
    &:hover {
      cursor: pointer;
    }
  }

  &__append-list {
    border-radius: 0;
  }
}

.sidebar {
  background: $dark !important;
  max-height: 100% !important;
  height: 100% !important;

  &__header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .v-window__container,
  .v-window,
  .v-item-group,
  .v-list {
    height: 100%;
  }

  .v-window-item {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &.mobile-active {
    z-index: 998 !important;
    width: 100% !important;
    height: calc(100% - 53px) !important;
    border-bottom: 1px solid $side-menu-main-text-color !important;
  }

  .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;

    .v-list-item {
      min-height: 36px;
      font-family: $card-body-font-family;

      &__name {
        max-width: 160px;
      }

      &__content {
        padding: 5px 0;
      }

      &__icon {
        margin: 6px 5px 6px 0;

        svg {
          fill: #a5a4bf;
        }
      }
    }

    .favourite {
      position: absolute;
      right: 15px;

      svg {
        fill: #a5a4bf;

        &:hover {
          fill: #fff;
        }
      }
    }
  }

  .v-list-item__title {
    color: $side-menu-main-title-color;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 600;
  }

  .v-list-group {
    position: relative;
  }

  &__exclamation-icon {
    position: absolute;
    width: 17px;
    top: 2px;
    margin-left: 8px;
  }

  &__menu-item {
    &::before {
      background: $focus-color;
    }

    &.active {
      .v-list-item__content {

        .v-list-item__title {
          color: #fff;
        }
      }

      @media (min-width: map-get($breakpoints, 'md')) {
        &::before {
          opacity: 0 !important;
        }
      }
    }

    .v-list-item__title {
      color: $side-menu-main-text-color;
      text-transform: none;
      font-size: 13px;
      overflow: visible;
    }

    .v-icon.icon-right {
      opacity: 0;
    }

    &:hover {
      .v-icon.icon-left {
        transform: translateX(-5px);
        transition: transform .5s, -webkit-transform .5s;
      }

      .v-icon.icon-right {
        opacity: 1;
        animation: opacity1 1s;
        transform: translateX(5px);
        transition: transform .5s, -webkit-transform .5s;
      }
    }

    &--bottom {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 20px;
      color: $side-menu-main-text-color;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 0 15px;

      &::before {
        opacity: 0 !important;
      }

      &-mini {
        padding: 0 18px;
      }

      .v-ripple__container {
        display: none !important;
      }

      i {
        color: #a1a4a8 !important;
      }

      .v-list-item__icon {
        margin-left: 0 !important;
      }
    }
  }

  &__list-group {
    &--mini {
      .v-list-group__header {
        min-height: auto !important;
      }
    }
  }

  &__bonus-wrapper {
    padding: 4px 18px;
    background: $color-warning;
    font-size: 11px;
    color: #000;
    font-weight: 600;
    width: 100%;
    white-space: nowrap;

    .v-list-item__icon {
      margin: 0;
    }
  }

  &__note {
    font-size: 0.7rem;
    color: $color-warning;
    position: relative;
    top: -7px;
    left: 6px;

    &--small {
      font-size: 0.65rem;
    }
  }
}

.mobile-menu {
  background: #161b25;
  width: 100%;
  height: 54px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;

  &__item {
    color: #fff;
    font-size: 11px;
    text-align: center;
    padding: 0 25px;
    line-height: 14px;
    opacity: 0.6;
    transition: 0.3s;

    &.active {
      opacity: 1;
    }
  }
}

.highlight-block {
  background: rgba(#8ce2b0, 0.125);
  border-radius: 10px;
  position: absolute;
  height: 100%;
  left: 7px;
  right: 7px;
  top: 0;

  &--mini {
    left: 7px;
    right: 7px;
  }
}

.no-links-hover {
  .sidebar__menu-item {
    &::before,
    .v-ripple__container {
      border-radius: 5px;
      left: 7px;
      width: calc(100% - 14px);
    }
  }
}
</style>
